// =========================================== Library Import ========================================
import Vue from "vue";
import axios from "axios";
import VeeValidate from "vee-validate";

// =========================================== Component Import ========================================
import App from "./App";
import global from "./components/global.js"
import moment from "moment";
import Avatar from 'vue-avatar';
import './registerServiceWorker';
import VModal from 'vue-js-modal';
import Toasted from 'vue-toasted';
import wysiwyg from "vue-wysiwyg";
import ElementUI from "element-ui";
import VueVisible from "vue-visible";
import Popover from "vue-js-popover";
import VueTelInput from "vue-tel-input";
import DatePicker from 'vue2-datepicker';
import VueOtpInput from "@bachdgvn/vue-otp-input";
import Multiselect from "vue-multiselect";
import { SweetModal } from "sweet-modal-vue";
import moment_timezone from "moment-timezone";
import ProgressBar from "vue-simple-progress";
import { HollowDotsSpinner } from "epic-spinners";
import * as VueGoogleMaps from "vue2-google-maps";
import VueRouterBackButton from 'vue-router-back-button';
import { ObserveVisibility } from 'vue-observe-visibility';
import VueRangeSlider from 'vue-range-component'
import VueCountdownTimer from 'vuejs-countdown-timer';
import vSelect from "vue-select";
import VueSweetalert2 from 'vue-sweetalert2';
import VueQRCodeComponent from 'vue-qr-generator'
import fullscreen from "vue-fullscreen";
import vueDebounce from 'vue-debounce'
import VueBus from 'vue-bus';

// =========================================== CSS Import ========================================
import "vue-wysiwyg/dist/vueWysiwyg.css";
import 'element-ui/lib/theme-chalk/index.css';
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-range-component/dist/vue-range-slider.css'
import "vue-select/dist/vue-select.css";
import 'sweetalert2/dist/sweetalert2.min.css';

// ============================================ JS Import ==============================================================
import router from "./router";
import store from './store/index';
import locale from "element-ui/lib/locale/lang/en";
import firebase from 'firebase/app';
require("firebase/messaging");

// ============================================ Library Configuration ==================================================
Vue.component("multiselect", Multiselect);
Vue.component("v-select", vSelect);
Vue.component("avatar", Avatar);
Vue.component("v-otp-input", VueOtpInput);
Vue.component('sweet-modal', SweetModal)
Vue.component('progress-bar', ProgressBar);
Vue.component("hollow-dots-spinner", HollowDotsSpinner);
Vue.directive('observe-visibility', ObserveVisibility)
var VueCookie = require("vue-cookie");
Vue.use(fullscreen);
Vue.use(firebase);
Vue.use(VueTelInput)
Vue.use(DatePicker)
Vue.use(wysiwyg, {});
Vue.use(VeeValidate);
Vue.use(VueCookie);
Vue.use(VModal);
Vue.use(vueDebounce);
Vue.use(Popover);
Vue.use(VueVisible);
Vue.use(Toasted);
Vue.component('qr-code', VueQRCodeComponent);
Vue.use(VueRangeSlider);
Vue.use(VueCountdownTimer);
Vue.use(ElementUI, { locale });
Vue.use(VueRouterBackButton, { router })
Vue.use(VueSweetalert2);
Vue.use(VueBus);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBGjCDSIw_duIshd1rXT4RdOC5JuLZWTiA",
    libraries: "places"
  }
});
Vue.config.silent = true
Vue.config.productionTip = false;
Vue.toasted.register(
  'success',
  message => {
    return message || 'Oops.. Something Went Wrong..'
  }, {
    type: 'success',
    position: 'top-center',
    duration: 2000,
    className: 'success_snack',
    closeOnSwipe: true
  }
)
Vue.toasted.register(
  'error',
  message => {
    return message || 'Oops.. Something Went Wrong..'
  }, {
    type: 'error',
    position: 'top-center',
    duration: 2000,
    className: 'error_snack',
    closeOnSwipe: false,
    fullWidth: false,
    theme: 'toasted-primary'

  }
)
Vue.prototype.$moment = moment;
Vue.prototype.moment_timezone = moment_timezone;
Vue.prototype.$serverUrl = global.HELP_API;
// var token = Vue.cookie.get("Token");
Vue.prototype.$http = axios.create({ 
  baseURL: Vue.prototype.$serverUrl,
  // headers: {
  //   Authorization: token,
  //   "Content-Type": "application/json",
  // },
 })

new Vue({
  el: "#app",
  router, 
  store,
  components: {
    App
  },
  template: "<App/>"
});
